/**
 * DealStatusBadgePremium - Badge de status com visual premium
 * Cores pastéis suaves e tamanho compacto estilo ClickUp
 * 
 * Versão: 1.0.0
 */
import React from 'react';
import { Trophy, XCircle, CircleDot } from 'lucide-react';
import { cn } from '@/lib/utils';
import { DealStatus } from '@/hooks/useCrmDeals';

// Props do componente
interface DealStatusBadgePremiumProps {
  status: DealStatus;
  className?: string;
  size?: 'xs' | 'sm';
}

// Configuração visual premium por status
const statusConfig: Record<DealStatus, { 
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  className: string;
}> = {
  open: {
    icon: CircleDot,
    label: 'Aberto',
    className: 'bg-sky-100 text-sky-700 dark:bg-sky-900/30 dark:text-sky-300'
  },
  won: {
    icon: Trophy,
    label: 'Ganho',
    className: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300'
  },
  lost: {
    icon: XCircle,
    label: 'Perdido',
    className: 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300'
  }
};

/**
 * Badge premium de status do Deal
 */
export function DealStatusBadgePremium({ 
  status, 
  className,
  size = 'xs'
}: DealStatusBadgePremiumProps) {
  const config = statusConfig[status];
  const Icon = config.icon;

  const sizeClasses = size === 'xs' 
    ? 'text-[10px] px-1.5 py-0.5 gap-1' 
    : 'text-xs px-2 py-0.5 gap-1.5';

  const iconSize = size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3';

  return (
    <span 
      className={cn(
        'inline-flex items-center font-medium rounded-full',
        sizeClasses,
        config.className,
        className
      )}
    >
      <Icon className={iconSize} />
      {config.label}
    </span>
  );
}
